module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/192nnbM/tc-custom/9781452125077.jpg?1737755769475",
      "alt": "This image is the cover for the book Macaroni & Cheese"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Macaroni & Cheese\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("“Sure to please even the most dedicated mac and cheese purist, while delighting anyone with a soft spot for comfort food.” —"), _c('i', [_vm._v("Publishers Weekly")])]), _c('br'), _c('br'), _vm._v("From the three-time James Beard Award nominee and author of "), _c('i', [_vm._v("Grilled Cheese")]), _vm._v(", this cookbook puts a variety of delicious spins on the kid-friendly favorite. More than fifty recipes range from the tried-and-true Yankee Doodle Dandy Baked Macaroni and Cheese and quick-to-prepare specialties such as the yodel-worthy Alpine Macaroni with Appenzeller and Crème Fraiche to international specialties like Giuvetchi, a Greek dish of orzo in a cinnamon tomato sauce with lamb and kasseri, myzithra, and feta cheeses. There are even a few dessert versions like Falooda, a traditional Indian treat, this one using ricotta and sweet vermicelli, with cherries and a touch of cardamom. "), _c('br'), _c('br'), _vm._v("Recipes for side salads and soups help round out a balanced meal. Mac & cheese—it’ll always please!\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Marlena Spieler, Noel Barnhurst\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Marlena Spieler is the author of over 50 cookbooks published worldwide, including Grilled Cheese, and has written for Bon Appétit and Saveur. She writes the San Francisco Chronicle award-winning food column \"The Roving Feast\" and is a three-time James Beard nominee. Born in Sacramento, California, she lives in Hampshire, England. Noel Barnhurst is a San Francisco–based photographer whose work has appeared in Bon Appétit and Fine Cooking.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Chronicle Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0